<template>
    <section class="login-section">
        <div class="login-container ">
            <div class="row">
                <header class="full-header">
                    <div class="top-header">
                        <div class="container">
                            <div class="row">
                                <div class="col-md-4 offset-md-4">
                                    <div class="topMessage">
                                        <p>Decide. Commit. Succeed!</p>
                                    </div>
                                </div>
                                <div class="top-header-sec col-md-4 col-xs-6 col-sm-8">
                                    <div class="pull-right">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="navbar-wrap">
                        <nav class="navbar topNavigation">
                            <div class="container">
                                <div class="navbar-header">
                                    <button type="button" class="navbar-toggle" data-toggle="collapse"
                                        data-target="#myNavbar">
                                        <span class="icon-bar"></span>
                                        <span class="icon-bar"></span>
                                        <span class="icon-bar"></span>
                                    </button>
                                    <a class="navbar-brand logoWrap" href="https://pro.dctrainings.com"><img
                                            src="./../../assets/images/logo.png" alt=""></a>
                                </div>
                                <div class="collapse navbar-collapse" id="myNavbar">
                                </div>
                            </div>
                        </nav>

                    </div>
                    <div class="header-content inner">
                        <div class="container">
                            <div class="row" style="justify-content: center;">
                                <div class="col-md-4 text-center contentbox contentbox-header box-header ">
                                    <h3 class="heading">Login</h3>
                                </div>
                            </div>
                            <div class="clear"></div>
                        </div>
                    </div>
                </header>
            </div>
        </div>
        <div class="contentArea membership-page">
            <div class="container">
                <div class="contentWrap col-md-12 p-2">
                    <h2>Login Here </h2>
                    <div class="col-md-8 offset-md-1 col-sm-8 offset-sm-1">
                        <form method="post" @submit.prevent="userLogin">
                            <br>
                            <div v-if="errMsg !== ''" class="text-center text-danger error-message">
                                {{ errMsg }}
                            </div>
                            <div class="p-2" v-if="message" :class="messageType">{{ message }}</div>
                            <div class="form-group">
                                <label class="control-label"><sup>*</sup>Email</label>
                                <input class="form-control" v-model="params.email" type="text" name="Email"
                                    placeholder="Email" required>
                                <div v-if="$v.params.email.$error" class=" text-danger error-message">
                                    This is a required field.
                                </div>
                                <div v-if="serverErr.email !== ''" class=" text-danger error-message">
                                    {{ serverErr.email }}
                                </div>
                            </div>
                            <!-- <div class="form-group">
                                <label class=" control-label"><sup>*</sup>Password</label>
                                <input class="form-control" v-model="params.password" type="password" name="Password"
                                    placeholder="Password" required>
                                <div v-if="$v.params.password.$error" class=" text-danger error-message">
                                    This is a required field.
                                </div>
                                <div v-if="serverErr.password !== ''" class=" text-danger error-message">
                                    {{ serverErr.password }}
                                </div>
                            </div> -->
                            <!-- <p class="text-right frgot-link" ><a href="javascript:void(0);" id="go_forget" >Forgot Password  <i
                                        class="" aria-hidden="true">?</i></a></p> -->
                            <router-link class="ml-5 auth-link float-right text-info " :to="{ name: 'user_login' }">
                                Go to login
                            </router-link>
                            <div class="form-group">
                                <button type="submit" class="btn btn-primary btn-lg">Recover Password</button>
                            </div>
                            <br>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <Footer />
    </section>
</template>

<script>
import router from "../../router";
import Footer from "./../layout/footer.vue";
import userAPI from "../userApi";
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
export default {
    name: "userLogin",
    components: { Footer },
    mixins: [validationMixin],
    data() {
        return {
            messageType: '',         // Style of the message ('success' or 'error')
            message: '',
            params: {
                email: "",
            },
            serverErr: {
                email: "",
            },
            errMsg: "",
            loginUser: {},
        }
    },
    validations: {
        params: {
            email: {
                required, email
            },
        }
    }
    ,
    methods: {
        userLogin() {
            this.$v.params.$touch();
            if (this.$v.params.$anyError) {
                return;
            }
            userAPI.forgetuserpassword(this.params, this.userLoginCB, this.errorLoginCb);
        },
        userLoginCB(res) {
            let user = res.data.data;
            if (user.token != undefined || user.token != null || user.token != '') {
                this.message = 'Password reset and sent to your email.';
                this.messageType = 'success';
                setTimeout(() => {
                    this.$router.push({ name: 'user_login' }); // Navigate to the login page after 2 seconds
                }, 2000);
            } else {
                this.$swal({
                    type: 'error',
                    title: 'Oops...',
                    text: "Something Wrong Please try again",
                })
            }
        },
        errorLoginCb(res) {
            if (typeof res.response.data.message == 'object') {
                this.serverErr.email = res.response.data.message.email[0];
                this.serverErr.password = res.response.data.message.password[0];
            } else {
                this.errMsg = res.response.data.message;
            }
        }
    }
}
</script>

<style scoped>
.success {
    color: green;
}

.error {
    color: red;
}
</style>
<style>
.full-header {
    width: 100%;
    background: url('./../../assets/images/shutterstock_217119211.jpg');
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
}

.login-section .header-content .box-header {
    margin-bottom: 15px;
    padding: 15px;
}

.full-header::before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(20, 55, 120, 0.7);
}

.topNavigation {
    background: -webkit-linear-gradient(to top, #dbeefe, #ffffff);
    /* For Safari 5.1 to 6.0 */
    background: -o-linear-gradient(to top, #dbeefe, #ffffff);
    /* For Opera 11.1 to 12.0 */
    /* For Firefox 3.6 to 15 */
    background: -webkit-gradient(linear, left bottom, left top, from(#dbeefe), to(#ffffff));
    background: -webkit-linear-gradient(bottom, #dbeefe, #ffffff);
    background: -o-linear-gradient(bottom, #dbeefe, #ffffff);
    background: linear-gradient(to top, #dbeefe, #ffffff);
    border: none;
    border-radius: 0;
    min-height: 56px;
    margin: 0;
}

.topNavigation .navbar-nav>li>a {
    text-transform: uppercase;
    padding-top: 14px;
    padding-bottom: 14px;
    font-size: 17px;
    color: #1b4463;
    position: relative;
    font-weight: bold;
    height: 60px;
    display: flex;
    align-items: center;
}

.topNavigation .navbar-nav>li:before {
    content: "";
    position: absolute;
    right: 0;
    height: 25px;
    width: 1px;
    top: 15px;
    background: #cfe8fc;
}

.topNavigation .navbar-nav>li:last-child:before {
    display: none;
}

.topNavigation .navbar-nav>li>a:hover,
.topNavigation .navbar-nav>li.active a {
    color: #ffffff;
    background: -webkit-gradient(linear, left bottom, left top, from(rgb(238, 167, 34)), to(rgb(229, 199, 81)));
    background: -webkit-linear-gradient(bottom, rgb(238, 167, 34) 0%, rgb(229, 199, 81) 100%);
    background: -o-linear-gradient(bottom, rgb(238, 167, 34) 0%, rgb(229, 199, 81) 100%);
    background: linear-gradient(to top, rgb(238, 167, 34) 0%, rgb(229, 199, 81) 100%);
}

.topNavigation .navbar-nav>li {
    position: relative;
    text-align: center;
}

.topNavigation .navbar-nav>li:after {
    content: "";
    position: absolute;
    right: 0;
    top: 16px;
    height: 25px;
    background: #cfe8fc;
    width: 1px;
}

.topNavigation .navbar-nav>li:last-child:after {
    display: none;
}

.topNavigation .navbar-toggle {
    background-color: rgb(67, 119, 192);
    border: 1px solid rgb(67, 119, 192);
}

.topNavigation .navbar-toggle .icon-bar {
    background: #ffffff;
}

.logoWrap {
    position: relative;
}

.logoWrap img {
    position: absolute;
    top: -22px;
    left: 181px;
}


.header-content {
    padding: 115px 0;
}

.header-content.inner {
    padding: 20px 0 0;
}

.top-header {
    padding: 15px 0;
    border-top: 4px solid #001e4b;
    position: relative;
}

.topMessage {
    color: #fff;
    text-align: center;
    border-radius: 50px;
    -webkit-box-shadow: 0 3px 8px rgba(255, 255, 255, 0.1);
    box-shadow: 0 3px 8px rgba(255, 255, 255, 0.1);
    padding: 5px;
    font-size: 22px;
    text-shadow: 0 0 9px;
}

.topMessage p {
    margin: 0;
}

/* content area*/
.contentArea {
    padding-top: 30px;
    margin-bottom: 20px;
}

.contentWrap {
    margin-top: 20px;
    background: #fff;
    border: 1px solid #ececec;
    border-radius: 5px;
    overflow: hidden;
}

.contentbox {
    padding: 15px;
    border-bottom: 1px solid #ececec;
    margin-bottom: 15px;
}

.frgot-link a {
    color: #474747;
}

.frgot-link a:hover {
    text-decoration: none;
}

.frgot-link a i {
    color: #b4d3ed;
    display: inline-block;
    width: 15px;
    height: 15px;
    background: #b4d3ed;
    border-radius: 50%;
    text-align: center;
    box-sizing: border-box;
    font-size: 12px;
    color: #fff;
    padding-right: 2px;
}

.contentbox:last-child {
    border: none;
}

.frgot-link {
    margin: 0;
}

.box-header .heading {
    font-size: 33px;
    color: #e89400;
    margin-top: 0;
    font-weight: bold;
}

.box-header h3 {
    font-size: 33px;
    color: #e89400;
    margin-top: 0;
    font-weight: bold;
}

header .box-header .heading {
    position: relative;
    color: #ffde52;
    font-size: 40px;
}

.box-header h4 {
    margin-bottom: 0;
    color: #454545;
    font-size: 20px;
}

.contentWrap form button.btn {
    padding: 5px 20px;
}


/* media quries*/
@media (min-width: 1200px) {
    .container {
        width: 1130px;
        padding: 0;
    }
}

@media (max-width: 991px) {
    .topNavigation .navbar-nav>li>a {
        font-size: 14px;
    }

    .topMessage {
        margin-bottom: 20px;
        font-size: 19px;
    }

    .header-content {
        padding: 60px 0;
    }

    a.navbar-brand.logoWrap img {
        height: 150px;
        width: 150px;
    }
}

@media (max-width: 768px) {

    .header-content {
        padding: 10px 0;
    }

    .box-header .heading {
        font-size: 30px;
    }
}

@media (max-width: 480px) {
    .topMessage {
        padding: 0;
        font-size: 15px;
        background: transparent;
        -webkit-box-shadow: none;
        box-shadow: none;
        margin-bottom: 0;
        padding-top: 3px;
        white-space: nowrap;
    }

    a.navbar-brand.logoWrap img {
        height: auto;
        width: 100px;
        top: -20px;
    }

    .box-header .heading {
        font-size: 24px;
    }
}
</style>